import { Navbar as SharedNavbar } from "@agent-todo/shared-ui"
import { useMantineColorScheme } from "@mantine/core"
import { IconKey, IconListDetails, IconUsers } from "@tabler/icons-react"
import { useNavigate } from "@tanstack/react-router"

import { useAuth } from "@/hooks/useAuth"
import { env } from "@/lib/env"

interface NavbarProps {
  onRefresh?: () => void
  isRefreshing?: boolean
  transparent?: boolean
}

export function Navbar({ onRefresh, isRefreshing, transparent = false }: NavbarProps) {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme()
  const { profile, signOut } = useAuth()
  const navigate = useNavigate()

  const envObject = {
    VITE_SUPABASE_URL: env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: env.VITE_SUPABASE_ANON_KEY,
    VITE_API_URL: env.VITE_API_URL,
    VITE_MONITORING_TOKEN: env.VITE_MONITORING_TOKEN,
    VITE_SENTRY_DSN: env.VITE_SENTRY_DSN,
    VITE_GIT_COMMIT_SHA: env.VITE_GIT_COMMIT_SHA,
  }

  const isAdmin = profile?.role === "admin" || profile?.role === "support"
  const navLinks = isAdmin
    ? [
        { label: "Env", href: "/env", icon: <IconKey size={16} /> },
        { label: "Jobs", href: "/jobs", icon: <IconListDetails size={16} /> },
        { label: "Users", href: "/users", icon: <IconUsers size={16} /> },
      ]
    : []

  return (
    <SharedNavbar
      appName="Agent Gate"
      logoSrc="/favicon.svg"
      subtitle={transparent ? undefined : "System Monitoring"}
      gradientColors={{ from: "#667eea", to: "#764ba2" }}
      transparent={transparent}
      colorScheme={colorScheme === "auto" ? "light" : colorScheme}
      onToggleColorScheme={toggleColorScheme}
      user={
        profile
          ? {
              email: profile.email,
              role: profile.role,
            }
          : null
      }
      onSignOut={() => {
        void signOut()
      }}
      onNavigate={(path) => {
        void navigate({ to: path })
      }}
      onRefresh={onRefresh}
      isRefreshing={isRefreshing}
      showEnvironmentInfo={!transparent}
      environmentVariables={envObject}
      environmentInfoRequiredRole="admin"
      navLinks={navLinks}
      hideAuthButtons={transparent}
    />
  )
}
